// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Attachment } from './attachment';
import { EmailMessageCustomerLink } from './email-message-customer-link';
import { EmailMessageInvoiceLink } from './email-message-invoice-link';
import { Quote } from './quote';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class EmailMessage extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  bcc?: string;
  body?: string;
  cc?: string;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  error?: string;
  quoteId?: number;
  sent?: Date;
  subject?: string;
  to?: string;
  attachments!: Attachment[];
  customerLinks!: EmailMessageCustomerLink[];
  invoiceLinks!: EmailMessageInvoiceLink[];
  quote!: Quote;
}

